module.exports = __webpack_public_path__ + "static/media/2.334ba795.jpg";